/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */

import React from 'react';
import { _ } from '@evershop/evershop/src/lib/locale/translate';
import { useLanguage } from '@components/common/locale/useLanguage';
import './ProductPicksMobile.scss';
import NoThumbnailMobile from '@components/frontStore/catalog/product/single/NoThumbnailMobile';
// import NewItemIconMobile from './NewItemIconMobile';

/**
 * A reusable food card component for displaying menu items
 */
export default function ProductPicksMobile(_ref) {
  var {
    storeStatus,
    image,
    name,
    isSpicy,
    description,
    url,
    price,
    currency = 'EGP',
    onAddToCart,
    isCustomizable
    // isNewItem
  } = _ref;
  var {
    isAr
  } = useLanguage();
  // const isNew = isNewItem?.is_new_item;

  var numericPrice = Number(price) || 0;
  var displayPrice = numericPrice ? numericPrice.toFixed(2) : '';
  var handleCardClick = e => {
    e.preventDefault();
    // Prevent navigation if store is closed
    if (storeStatus === '0') {
      return;
    }
    onAddToCart();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "product-picks relative flex flex-col justify-between mx-auto w-full max-w-[21rem] h-full",
    onClick: handleCardClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute left-1/2 top-[-5.25rem] -translate-x-1/2  w-full flex justify-center z-[50]"
  }, /*#__PURE__*/React.createElement("a", {
    href: storeStatus === '0' ? '/' : url,
    onClick: handleCardClick
  }, image ? /*#__PURE__*/React.createElement("img", {
    src: image.single || image,
    alt: name,
    className: "!h-[14rem]"
  }) : /*#__PURE__*/React.createElement("div", {
    className: "scale-75"
  }, /*#__PURE__*/React.createElement(NoThumbnailMobile, null)))), /*#__PURE__*/React.createElement("div", {
    className: "p-[0.5rem] pt-[8rem] pb-6 flex-grow flex flex-col justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-between relative px-[0.5rem]"
  }, isSpicy && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
    src: "/assets/card/spicy-icon-mobile.svg",
    alt: "Spicy",
    className: "absolute ltr:block rtl:hidden ltr:right-0 rotate-[15deg] rtl:left-0 top-[-32px] z-30"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/assets/card/spicy-icon-mobile-ar.svg",
    alt: "\u062D\u0627\u0631",
    className: "absolute ltr:hidden rtl:block rotate-[-15deg] ltr:right-0 rtl:left-0 top-[-32px] z-30"
  })), /*#__PURE__*/React.createElement("h3", {
    className: "product-picks-title mb-[0.2rem]"
  }, name), description && /*#__PURE__*/React.createElement("p", {
    className: "product-picks-description mb-[0.4rem] line-clamp-2"
  }, typeof description === 'string' ? description : _('Description unavailable'))), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center mt-[0.4rem]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full max-w-[14rem]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-[#F5F5F5] rounded-[0.4rem] py-1 flex items-center justify-center"
  }, numericPrice > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "flex items-baseline gap-1"
  }, isAr ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "product-picks-price !font-rubik font-bold text-[#060708]"
  }, displayPrice), /*#__PURE__*/React.createElement("span", {
    className: "product-picks-currency font-medium text-[#060708]"
  }, "\u062C\u0645")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "product-picks-currency font-medium text-[#060708]"
  }, currency), /*#__PURE__*/React.createElement("span", {
    className: "product-picks-price !font-rubik font-bold text-[#060708]"
  }, displayPrice))) : /*#__PURE__*/React.createElement("span", {
    className: "text-[1.1rem] text-[#060708]"
  }, _('Price upon selection')))))), /*#__PURE__*/React.createElement("div", {
    className: "add-to-cart-section relative"
  }, /*#__PURE__*/React.createElement("img", {
    src: !isCustomizable ? '/assets/card/card-red-lines.svg' : '/assets/card/card-black-lines.svg',
    alt: !isCustomizable ? 'red-lines' : 'black-lines',
    className: "red-lines-img"
  }), /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 flex items-center justify-between px-[0.7rem]"
  }, !isCustomizable ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: " uppercase bg-[#fff] rounded-[0.4rem] p-[0.3rem] font-bold text-[1.4rem] font-zoom-pro-normal ".concat(storeStatus === '0' ? 'text-[#afafaf]' : 'text-primary')
  }, _('ADD TO CART')), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onAddToCart,
    disabled: storeStatus === '0',
    className: "rounded-full bg-primary text-[#2A2A2A] disabled:bg-[#7B7B7B] disabled:cursor-not-allowed flex items-center justify-center shrink-0 w-[3.6rem] h-[3.6rem]",
    "aria-label": "Add to cart"
  }, /*#__PURE__*/React.createElement("svg", {
    className: " ".concat(storeStatus === '0' ? 'opacity-30' : 'opacity-100'),
    xmlns: "http://www.w3.org/2000/svg",
    width: "22",
    height: "22",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: storeStatus === '0' ? '#fff' : '#fff',
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 5v14M5 12h14"
  })))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: "text-[#2A2A2A] uppercase bg-[#fff] rounded-[0.4rem] p-[0.3rem] font-bold text-[1.4rem] font-zoom-pro-normal ".concat(storeStatus === '0' ? 'text-[#afafaf]' : 'text-[#2A2A2A]', "   ")
  }, _('Customize')), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onAddToCart,
    disabled: storeStatus === '0',
    className: "rounded-full disabled:cursor-not-allowed flex items-center justify-center shrink-0 w-[3.6rem] h-[3.6rem]",
    "aria-label": "Customize"
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "w-[3.6rem] h-[3.6rem] ".concat(isAr ? 'rotate-180' : '')
  }, /*#__PURE__*/React.createElement("rect", {
    width: "32",
    height: "32",
    rx: "16",
    fill: storeStatus === '0' ? '#7B7B7B' : '#060708'
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8721 22.5529C16.8094 22.4902 16.7596 22.4158 16.7256 22.3339C16.6916 22.2519 16.6742 22.1641 16.6742 22.0754C16.6742 21.9867 16.6916 21.8988 16.7256 21.8169C16.7596 21.7349 16.8094 21.6605 16.8721 21.5978L21.7954 16.6754L8.57469 16.6754C8.39567 16.6754 8.22398 16.6043 8.09739 16.4777C7.9708 16.3511 7.89969 16.1794 7.89969 16.0004C7.89969 15.8214 7.9708 15.6497 8.09739 15.5231C8.22398 15.3965 8.39567 15.3254 8.57469 15.3254L21.7954 15.3254L16.8721 10.4029C16.7455 10.2763 16.6743 10.1045 16.6743 9.92537C16.6743 9.74625 16.7455 9.57447 16.8721 9.44781C16.9988 9.32116 17.1706 9.25 17.3497 9.25C17.5288 9.25 17.7006 9.32116 17.8273 9.44781L23.9023 15.5228C23.965 15.5855 24.0148 15.6599 24.0488 15.7419C24.0827 15.8238 24.1002 15.9117 24.1002 16.0004C24.1002 16.0891 24.0827 16.1769 24.0488 16.2589C24.0148 16.3408 23.965 16.4152 23.9023 16.4779L17.8273 22.5529C17.7646 22.6157 17.6901 22.6655 17.6082 22.6995C17.5262 22.7334 17.4384 22.7509 17.3497 22.7509C17.261 22.7509 17.1731 22.7334 17.0912 22.6995C17.0093 22.6655 16.9348 22.6157 16.8721 22.5529Z",
    fill: "white"
  })))))));
}